import CustomButton from 'components/Buttons/CustomButton'
import { useEffect, useState } from 'react'
import { AlertCircle } from 'react-feather'
import { useSelector } from 'react-redux'
import { FormGroup, Input, Label, Modal, ModalBody } from 'reactstrap'
import { useEditCategoryMutation } from '../payable-notes/payableNotesApiSlice'
import {
  useLazyGetCategoriesCashFlowQuery,
  useLazyGetCategoriesCashFlowPersonalQuery,
  usePostCategorCashFlowMutation,
  usePostCategorCashFlowPersonalMutation,
} from './cashFlowApiSlice'

const ModalCategory = ({ isOpen, toggle, row, isIncome, isPersonal }) => {
  const [errMsg, setErrMsg] = useState('')
  const [category, setCategory] = useState('')

  const { profile } = useSelector((s) => s.dashboard)
  const [editCategory, result] = useEditCategoryMutation()
  const [postCategory, result2] = usePostCategorCashFlowMutation()
  const [postCategoryPersonal, result3] = usePostCategorCashFlowPersonalMutation()
  const [getCategories] = useLazyGetCategoriesCashFlowQuery()
  const [getCategoriesPersonal] = useLazyGetCategoriesCashFlowPersonalQuery()

  const handleSubmit = async () => {
    try {
      let body = {}
      if (row) {
        body = {
          label: category,
          id: row?.id,
        }
      } else {
        body = {
          label: category,
          incomeorexpense: isIncome ? 'income' : 'expense',
        }
      }
      const resp = row
        ? await editCategory(body).unwrap()
        : await (isPersonal ? postCategoryPersonal(body) : postCategory(body)).unwrap()
      if (!resp?.data?.error) {
        toggle()
        const refetchParams = {
          type: isIncome ? 'income' : 'expense',
          active: 1,
          userId: profile?.userId,
        }
        if (isPersonal) {
          getCategoriesPersonal(refetchParams)
        } else {
          getCategories(refetchParams)
        }
      } else {
        throw resp
      }
    } catch (error) {
      setErrMsg(error?.data?.message ?? error?.message)
    }
  }

  useEffect(() => {
    if (row && isOpen) {
      setCategory(row?.label)
    } else {
      setCategory(null)
    }
  }, [row, isOpen])

  return (
    <Modal
      className="p-4"
      centered
      isOpen={isOpen}
      toggle={() => {
        toggle()
        setErrMsg('')
      }}
      autoFocus={false}
    >
      <ModalBody>
        <h5>{row ? 'Edit' : 'Tambah'} kategori</h5>
        <FormGroup className="mt-3">
          <Label>Nama kategori</Label>
          <Input
            autoFocus={true}
            value={category ?? ''}
            onChange={(e) => {
              setCategory(e.target.value)
              setErrMsg('')
            }}
            placeholder="Cth: Beli pupuk"
          />
        </FormGroup>
        {errMsg && (
          <small className="text-danger">
            <AlertCircle size={15} /> {errMsg}
          </small>
        )}
        <div className="d-flex gap-3 mt-4">
          <CustomButton
            onClick={() => {
              toggle()
              setErrMsg('')
            }}
            disabled={result?.isLoading || result2?.isLoading}
            color="primary"
            outline
            block
          >
            Batal
          </CustomButton>
          <CustomButton
            disabled={!category || result?.isLoading || result2?.isLoading}
            onClick={handleSubmit}
            color="primary"
            block
          >
            Simpan
          </CustomButton>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ModalCategory
